var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03044 16.0303C6.73755 16.3232 6.26268 16.3232 5.96978 16.0303C5.67689 15.7374 5.67689 15.2626 5.96978 14.9697L7.96978 12.9697L9.03044 14.0303L7.03044 16.0303Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9698 16.0303L14.9698 14.0303L16.0304 12.9697L18.0304 14.9697C18.3233 15.2626 18.3233 15.7374 18.0304 16.0303C17.7376 16.3232 17.2627 16.3232 16.9698 16.0303Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 7C3.25 6.0335 4.0335 5.25 5 5.25H19C19.9665 5.25 20.75 6.0335 20.75 7V17C20.75 17.9665 19.9665 18.75 19 18.75H5C4.0335 18.75 3.25 17.9665 3.25 17V7ZM4.75 17V7.79541L10.056 13.1014C11.1299 14.1753 12.8711 14.1753 13.9451 13.1014L19.25 7.79644V17C19.25 17.1381 19.1381 17.25 19 17.25H5C4.86193 17.25 4.75 17.1381 4.75 17ZM5.82591 6.75H18.1751L12.8844 12.0407C12.3962 12.5289 11.6048 12.5289 11.1166 12.0407L5.82591 6.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1decf4bc.svg";
export { ForwardRef as ReactComponent };